import util from '@/libs/util'

//外籍雇员管理列表
export function companyAttendancePage(params) {
  return util.http({
    method: 'get',
    url: 'org/auth/companyAttendance/page',
    params
  })
}

//考勤明细信息
export function companyAttendanceRecordPage(params) {
  return util.http({
    method: 'get',
    url: 'org/auth/companyAttendanceRecord/page',
    params
  })
}

// 修改考勤信息
export function companyAttendanceRecordPut(data) {
  return util.http({
    method: 'put',
    url: 'org/auth/companyAttendanceRecord',
    data
  })
}

// 新增考勤
export function companyAttendanceAdd(data) {
  return util.http({
    method: 'post',
    url: 'org/auth/companyAttendance',
    data
  })
}

// 修改考勤
export function companyAttendancePut(data) {
  return util.http({
    method: 'put',
    url: 'org/auth/companyAttendance',
    data
  })
}

// 提交审核
export function companyAttendanceSubmitAudit(params) {
  return util.http({
    method: 'put',
    url: 'org/auth/companyAttendance/submitAudit',
    params
  })
}

// 撤回审核
export function companyAttendanceCancelSubmit(params) {
  return util.http({
    method: 'put',
    url: 'org/auth/companyAttendance/cancelSubmit',
    params
  })
}

// 审核
export function companyAttendanceAudit(data) {
  return util.http({
    method: 'put',
    url: 'org/auth/companyAttendance/audit',
    data
  })
}

//待办
export function companyAttendanceMessage(params) {
  return util.http({
    method: 'get',
    url: 'org/auth/companyAttendance/message',
    params
  })
}

// 企业考勤退回
export function companyAttendanceRollback(id) {
  return util.http({
    method: 'put',
    url: `org/auth/companyAttendance/rollback?companyAttendanceId=${id}`
  })
}

//关键数据
export function companyAttendanceStatisticsKeyData(params) {
  return util.http({
    method: 'get',
    url: 'org/auth/companyAttendanceStatistics/keyData',
    params
  })
}

// 导入失败时下载模板
export function downloadErr(params) {
  return util.http({
    method: 'get',
    url: 'api/auth/file/common/download',
    params,
    responseType: 'blob'
  })
}

//获取初始化信息，模板下载地址
export function companyAttendanceInit(params) {
  return util.http({
    method: 'get',
    url: 'org/auth/companyAttendance/init',
    params
  })
}

// 节假日加班审批列表
export function companyAttendanceHolidayPage(params) {
  return util.http({
    method: 'get',
    url: 'org/auth/companyAttendanceHoliday/page',
    params
  })
}

// 节假日加班审核
export function companyAttendanceHolidayAudit(data) {
  return util.http({
    method: 'put',
    url: 'org/auth/companyAttendanceHoliday/audit',
    data
  })
}

// 双休加班审批列表
export function companyAttendanceWeekendPage(params) {
  return util.http({
    method: 'get',
    url: 'org/auth/companyAttendanceWeekend/page',
    params
  })
}

// 双休加班审核
export function companyAttendanceWeekendAudit(data) {
  return util.http({
    method: 'put',
    url: 'org/auth/companyAttendanceWeekend/audit',
    data
  })
}

// 夜餐补助审批列表
export function companyAttendanceNightPage(params) {
  return util.http({
    method: 'get',
    url: 'org/auth/companyAttendanceNight/page',
    params
  })
}

// 夜餐补助审核
export function companyAttendanceNightAudit(data) {
  return util.http({
    method: 'put',
    url: 'org/auth/companyAttendanceNight/audit',
    data
  })
}

// 出差确认审批列表
export function companyAttendanceBusinessPage(params) {
  return util.http({
    method: 'get',
    url: 'org/auth/companyAttendanceBusiness/page',
    params
  })
}

// 出差确认审核
export function companyAttendanceBusinessAudit(data) {
  return util.http({
    method: 'put',
    url: 'org/auth/companyAttendanceBusiness/audit',
    data
  })
}

// 分页查询企业考勤配置列表
export function companyAttendanceConfigPage(params) {
  return util.http({
    method: 'get',
    url: 'org/auth/companyAttendanceConfig/page',
    params
  })
}

// 新增考勤配置
export function companyAttendanceConfigAdd(data) {
  return util.http({
    method: 'post',
    url: 'org/auth/companyAttendanceConfig',
    data
  })
}

// 修改考勤配置
export function companyAttendanceConfigPut(data) {
  return util.http({
    method: 'put',
    url: 'org/auth/companyAttendanceConfig',
    data
  })
}

// 分页查询企业职工列表
export function companyEmployeePage(params) {
  return util.http({
    method: 'get',
    url: 'org/auth/companyEmployee/page',
    params
  })
}

// 考勤配置详情
export function companyAttendanceConfigDetail(params) {
  return util.http({
    method: 'get',
    url: 'org/auth/companyAttendanceConfig/' + params
  })
}

// 删除节假日审批表
export function holidayDelete(params) {
  return util.http({
    method: 'delete',
    url: `org/auth/companyAttendanceHoliday`,
    params
  })
}

// 删除双休审批表
export function weekendDelete(params) {
  return util.http({
    method: 'delete',
    url: `org/auth/companyAttendanceWeekend`,
    params
  })
}

// 删除出差审批表
export function businessDelete(params) {
  return util.http({
    method: 'delete',
    url: `org/auth/companyAttendanceBusiness`,
    params
  })
}

// 删除夜餐审批表
export function nightDelete(params) {
  return util.http({
    method: 'delete',
    url: `org/auth/companyAttendanceNight`,
    params
  })
}

// 删除
export function recordDelete(params) {
  return util.http({
    method: 'delete',
    url: `org/auth/companyAttendanceRecord`,
    params
  })
}

//组织机构列表
export function organizationPage(params) {
  return util.http({
    method: 'get',
    url: 'org/auth/organization/page',
    params
  })
}

//组织机构列表
export function employeePage(params) {
  return util.http({
    method: 'get',
    url: 'org/auth/employee/page',
    params
  })
}

//请假审批列表
export function companyAttendanceLeavePage(params) {
  return util.http({
    method: 'get',
    url: 'org/auth/companyAttendanceLeave/page',
    params
  })
}

// 请假修改
export function companyAttendanceLeavePut(data) {
  return util.http({
    method: 'put',
    url: 'org/auth/companyAttendanceLeave',
    data
  })
}

//请假删除
export function companyAttendanceLeaveDelete(params) {
  return util.http({
    method: 'delete',
    url: 'org/auth/companyAttendanceLeave',
    params
  })
}

// 请假审核
export function companyAttendanceLeaveAudit(data) {
  return util.http({
    method: 'put',
    url: 'org/auth/companyAttendanceLeave/audit',
    data
  })
}

//旷工列表
export function employeeAbsenteeismPage(params) {
  return util.http({
    method: 'get',
    url: 'org/auth/employeeAbsenteeism/page',
    params
  })
}

//旷工新增
export function employeeAbsenteeismAdd(data) {
  return util.http({
    method: 'post',
    url: 'org/auth/employeeAbsenteeism',
    data
  })
}

//旷工修改
export function employeeAbsenteeismPut(data) {
  return util.http({
    method: 'put',
    url: 'org/auth/employeeAbsenteeism',
    data
  })
}

//旷工删除
export function employeeAbsenteeismDelete(params) {
  return util.http({
    method: 'delete',
    url: 'org/auth/employeeAbsenteeism',
    params
  })
}

//职工修改
export function employeePut(data) {
  return util.http({
    method: 'put',
    url: 'org/auth/employee',
    data
  })
}
